import { hideNavbarSearch } from './navbar-search';

export function clearInput(e) {
  e.preventDefault();

  const btn = e.target;
  const input = btn.parentElement.querySelector('.form-control');
  const form = btn.closest('form') || null;

  // If Navbar Search, Hide Search w/ Empty Input
  if (
    (!!form && form.id === 'navbar-search-form') ||
    (form.id === 'cludo-search-form' && !input.value)
  ) {
    hideNavbarSearch(form);
  } else {
    input.value = '';
    input.focus();
  }
}

export function initializeClearInput() {
  const clearInputButtons = Array.from(
    document.querySelectorAll('.clear-input')
  );
  clearInputButtons.forEach((clearInputButton) => {
    clearInputButton.addEventListener('click', (e) => clearInput(e));
  });
}
